// extracted by css-extract-rspack-plugin
export default {"title":"Pah9jKWpL8oBhBRB"};